// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html, body, #root, .app-container {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
  }
.map-container {
    position: inherit;
    width: 100%;
    height: 100%;
  }
  .popup-container {
    position: absolute;
    bottom: 10px;
    left: 10px;
    background: white;
    padding: 10px;
    border: 1px solid black;
  }
  
  .popup h3 {
    margin-top: 0;
  }`, "",{"version":3,"sources":["webpack://./src/pages/MapApproach2/map-container.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;IACX,SAAS;IACT,UAAU;EACZ;AACF;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,aAAa;EACf","sourcesContent":["html, body, #root, .app-container {\r\n    height: 100%;\r\n    width: 100%;\r\n    margin: 0;\r\n    padding: 0;\r\n  }\r\n.map-container {\r\n    position: inherit;\r\n    width: 100%;\r\n    height: 100%;\r\n  }\r\n  .popup-container {\r\n    position: absolute;\r\n    bottom: 10px;\r\n    left: 10px;\r\n    background: white;\r\n    padding: 10px;\r\n    border: 1px solid black;\r\n  }\r\n  \r\n  .popup h3 {\r\n    margin-top: 0;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
